import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Breadcrumbs = ({ items }) => {
  return (
    <nav className="bg-gray-50 border-b border-gray-200 py-3">
      <div className="max-w-[1400px] mx-auto px-8 lg:px-12">
        <ol className="flex items-center space-x-2 text-sm">
          <li>
            <Link to="/" className="flex items-center text-gray-600 hover:text-slate-700 transition-colors">
              <Home className="h-4 w-4" />
            </Link>
          </li>
          {items.map((item, index) => (
            <li key={index} className="flex items-center">
              <ChevronRight className="h-4 w-4 text-gray-400 mx-2" />
              {index === items.length - 1 ? (
                <span className="text-gray-900 font-semibold">{item.label}</span>
              ) : (
                <Link to={item.path} className="text-gray-600 hover:text-slate-700 transition-colors">
                  {item.label}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumbs;